import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchFriends,
  selectFriendsData,
  selectFriendsError,
  selectFriendsLoading,
  AppDispatch
} from '@/shared';

export const useFriends = (defaultLoading = true) => {
  const dispatch = useDispatch<AppDispatch>(); // Use the AppDispatch type for dispatch
  const data = useSelector(selectFriendsData);
  const loading = useSelector(selectFriendsLoading);
  const error = useSelector(selectFriendsError);

  // Fetch airdrop info on mount and set up refresh every minute
  useEffect(() => {
    if (!data && defaultLoading) {
      dispatch(fetchFriends({}));
    }
  }, [dispatch, data]);

  // Manual refresh
  const refresh = () => {
    if (!loading) {
      dispatch(fetchFriends({}));
    }
  };

  return { data, loading, error, refresh };
};
